import { Text } from "components/Typography/text.styled";
import { FontFamily, FontSize } from "config/font";
import React, { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useCompanyStore } from "web-apps/company/stores/companyStore/companyStore";
import { TabStyled } from "../tab/tab.styled";
import { AGIOverview } from "./agiOverview.component";
import { IndividualSalary } from "./individualSalary.component";
import { MonthlySalary } from "./monthlySalary.component";
import { MonthOverview } from "./monthOverview.component";
import { StyledTabGroup } from "./salary.styled";
import { SalaryExportsOverview } from "./salaryExports.component";

export const SalaryTabs: React.FC = () => {
  const [currentTab, setCurrentTab] = useState<
    "MonthOverview" | "Monthly" | "Individual" | "AGI" | "Exports"
  >("MonthOverview");
  const { t } = useTranslation();
  const [companyState] = useCompanyStore();

  const haveSalaryModule = useMemo(() => {
    return (
      companyState.companySettings?.find(
        (s: any) => s.key === "EnableCompanySalaryView"
      )?.value == "true"
    );
  }, [companyState.companySettings]);

  return (
    <>
      <StyledTabGroup>
        <TabStyled
          active={currentTab === "MonthOverview"}
          onClick={() => setCurrentTab("MonthOverview")}
        >
          <Text
            fontFamily={
              currentTab === "MonthOverview"
                ? FontFamily.MontserratSemiBold
                : FontFamily.MontserratRegular
            }
            fontSize={FontSize.Large}
          >
            {t("Salary.Salaries")}
          </Text>
        </TabStyled>
        {haveSalaryModule && (
          <>
            <TabStyled
              active={currentTab === "Monthly"}
              onClick={() => setCurrentTab("Monthly")}
            >
              <Text
                fontFamily={
                  currentTab === "Monthly"
                    ? FontFamily.MontserratSemiBold
                    : FontFamily.MontserratRegular
                }
                fontSize={FontSize.Large}
              >
                {t("Salary.MonthlySalary")}
              </Text>
            </TabStyled>

            <TabStyled
              active={currentTab === "Individual"}
              onClick={() => setCurrentTab("Individual")}
            >
              <Text
                fontFamily={
                  currentTab === "Individual"
                    ? FontFamily.MontserratSemiBold
                    : FontFamily.MontserratRegular
                }
                fontSize={FontSize.Large}
              >
                {t("Salary.IndividualSalary")}
              </Text>
            </TabStyled>

            <TabStyled
              active={currentTab === "AGI"}
              onClick={() => setCurrentTab("AGI")}
            >
              <Text
                fontFamily={
                  currentTab === "AGI"
                    ? FontFamily.MontserratSemiBold
                    : FontFamily.MontserratRegular
                }
                fontSize={FontSize.Large}
              >
                {t("Salary.AGI")}
              </Text>
            </TabStyled>
          </>
        )}
        {!haveSalaryModule && (
          <TabStyled
            active={currentTab === "Exports"}
            onClick={() => setCurrentTab("Exports")}
          >
            <Text
              fontFamily={
                currentTab === "Exports"
                  ? FontFamily.MontserratSemiBold
                  : FontFamily.MontserratRegular
              }
              fontSize={FontSize.Large}
            >
              {t("Salary.SalaryExports")}
            </Text>
          </TabStyled>
        )}
      </StyledTabGroup>
      {currentTab === "MonthOverview" && <MonthOverview />}
      {currentTab === "Monthly" && <MonthlySalary />}
      {currentTab === "Individual" && <IndividualSalary />}
      {currentTab === "AGI" && <AGIOverview />}
      {currentTab === "Exports" && <SalaryExportsOverview />}
    </>
  );
};
